import React from "react";
import * as S from "./Styles";

interface OverlayMenuProps {
  isOpen: boolean;
  closeMenu: () => void;
}

const OverlayMenu = ({ isOpen, closeMenu }: OverlayMenuProps) => {
  return (
    <S.Overlay $isOpen={isOpen}>
      <S.NameContainer>
        <S.Name>Grønvold</S.Name>
        <S.Name>Byggservice</S.Name>
      </S.NameContainer>
      <S.MenuList $isOpen={isOpen}>
        <S.MenuItem onClick={closeMenu} to="/">
          Hjem
        </S.MenuItem>
        <S.MenuItem onClick={closeMenu} to="/om-oss">
          Om oss
        </S.MenuItem>
        <S.MenuItem onClick={closeMenu} to="/kontakt">
          Kontakt
        </S.MenuItem>
      </S.MenuList>
    </S.Overlay>
  );
};

export default OverlayMenu;
